module.exports = __webpack_public_path__ + "img/banner-dex-mobile.fb96bd32.webp";